(function CaptchaV3($, Adzuki) {
	"use strict";

	$(document).ready(function documentReady() {
		$('.g-recaptcha').on('click', function onCaptchaSubmit(e) {
			let siteKey = window.myGcapSiteKey;
			let $form = $(this).closest('form');
			e.preventDefault();

			// eslint-disable-next-line no-undef
			grecaptcha.ready(function readyCaptcha() {
				// eslint-disable-next-line no-undef
				grecaptcha.execute(siteKey, {action: 'submit'}).then(function processToken(token) {
					Adzuki.Ajax.get(Adzuki.base_uri+'/CaptchaThree/checkCaptcha/' + token)
						.then(function success(data) {
							if (data.success && data.score >= 0.5) {
								$form.submit();
							}
						});
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
